<!-- #region HTML -->
<template>
  <div class="app">
    <div class="main-container form-container">
      <div>
        <!-- #region Complete Check Image -->
        <img class="complete-check" alt="完了" src="@/assets/img/complete-check.svg" width="100%" />
        <!-- #endregion -->

        <!-- #region Complete Title -->
        <div class="complete-title">アカウントを登録しました</div>
        <!-- #endregion -->

        <!-- #region Submit Container -->
        <div class="submit-container flex-center">
          <div class="description">
            5秒後にジャンプします。ジャンプしない場合は、<a :href="path">こちら</a>をクリックしてください。
          </div>
        </div>
        <!-- #endregion Submit Container -->
      </div>
    </div>
  </div>
</template>
<!-- #endregion HTML -->

<!-- #region JavaScript -->
<script>
// リファラによって登録完了後の遷移先を設定
const setPath = (referrer) => {
  const urlPattern = {
    shop: /^https:\/\/(st\.)*eowp-shop\.alc\.co\.jp\S*/,
    lp: /^https:\/\/lp\.eowp\.alc\.co\.jp\S*/,
    eowpf: /^https:\/\/(dev-)?(eowp|eowpf|eowf)(2|3)?\.alc\.co\.jp\/\S*/,
    eow: /^https:\/\/(dev-)*eow(2)*\.alc\.co\.jp\S*/,
  }
  let path = '';
  const origin = referrer.substring(0, referrer.indexOf('alc.co.jp') + 9);

  if (!referrer) {
    path = '';
  } else if (referrer.match(urlPattern.shop)) {
    path = origin + '/products';
  } else if (referrer.match(urlPattern.lp)) {
    path = 'https://eowp-shop.alc.co.jp/products';
  } else if (referrer.match(urlPattern.eowpf)) {
    const pfEnv = {
      dev: /^https:\/\/dev-(eowp|eowpf|eowf)\.alc\.co\.jp/,
      stg: /^https:\/\/(eowp|eowpf|eowf)(2|3)\.alc\.co\.jp/,
      prd: /^https:\/\/(eowp|eowpf|eowf)\.alc\.co\.jp/,
    }
    if (origin.match(pfEnv.dev)) {
      path = 'https://dev-eowpf.alc.co.jp/login';
    } else if (origin.match(pfEnv.stg)) {
      path = 'https://eowpf2.alc.co.jp/login';
    } else if (origin.match(pfEnv.prd)) {
      path = 'https://eowpf.alc.co.jp/login';
    }
  } else if (referrer.match(urlPattern.eow)) {
    const query = referrer.replace(origin, '');
    const eowEnv = {
      dev: /^https:\/\/dev-eow\.alc\.co\.jp/,
      stg: /^https:\/\/eow2\.alc\.co\.jp/,
      prd: /^https:\/\/eow\.alc\.co\.jp/,
    }
    if (origin.match(eowEnv.dev)) {
      path = 'https://dev-eowf.alc.co.jp' + query;
    } else if (origin.match(eowEnv.stg)) {
      path = 'https://eowf2.alc.co.jp' + query;
    } else if (origin.match(eowEnv.prd)) {
      path = 'https://eowf.alc.co.jp' + query;
    }
  }
  return path
}

export default {
  name: 'CompleteSignup',
  data: () => ({
    path: '/',
    redirectTimeout: null, 
  }),
  created() {
    const referrer = this.$route.params.ref;
    const nextPath = setPath(referrer);
    if (nextPath) {
      this.path = nextPath;
    }

    this.redirectTimeout = setTimeout(() => {
      if (nextPath) {
        location.href = nextPath;
      } else {
        this.$router.push({ name: 'home' });
      }
    }, 5000);
  },
  beforeDestroy() {
    if (this.redirectTimeout) {
      clearTimeout(this.redirectTimeout);
    }
  },
}

</script>
<!-- #endregion -->
